"use client"

import { HandHeart } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HandHeartIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HandHeartIcon = component(Icon)({ as: HandHeart })
